import krishna_bg from "../images/naming_ceremony/naming_ceremony1.png";
import '../invitations/Invitation.css'

const namingceremonyInvitationElements = [

  // 🪶 TOP FEATHER DECOR
  {
    id: 1,
    type: "text",
    text: "🪶",
    x: 30,
    y: 50,
    fontSize: 50,
    fontFamily: "Poppins",
    fill: "#d4af37" // gold
  },

  {
    id: 20,
    type: "text",
    text: "🪶",
    x: 490,
    y: 50,
    fontSize: 50,
    fontFamily: "Poppins",
    fill: "#d4af37" // gold
  },

  // ✨ TOP DIVIDER
  {
    id: 2,
    type: "text",
    text: "✦ ✦ ✦",
    x: 260,
    y: 50,
    fontSize: 18,
    fontFamily: "Poppins",
    fill: "#d4af37" // gold
  },

  // 💫 BLESSING TEXT
  {
    id: 3,
    type: "text",
    text: "With the divine blessings of Lord Krishna",
    x: 90,
    y: 80,
    fontSize: 30,
    fontFamily: "Great Vibes",
    fill: "#1e3a8a"
  },

  // 💎 MAIN TITLE
  {
    id: 4,
    type: "text",
    text: "Naming Ceremony",
    x: 80,
    y: 130,
    fontSize: 54,
    fontFamily: "Playfair Display",
    fill: "#1e3a8a"
  },

  // ✨ GOLD LINE
  {
    id: 5,
    type: "text",
    text: "──────── ✦ ────────",
    x: 160,
    y: 190,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#d4af37"
  },

  // 🎵 FLUTE ICON
  {
    id: 6,
    type: "text",
    text: "🪈",
    x: 80,
    y: 230,
    fontSize: 42,
    fontFamily: "Dancing Script",
    fill: "#1e40af"
  },

  // 👶 BABY NAME (CENTER FOCUS)
  {
    id: 7,
    type: "text",
    text: "Little Krishna",
    x: 150,
    y: 230,
    fontSize: 42,
    fontFamily: "Dancing Script",
    fill: "#1e40af"
  },

  // 👶 SMALL EMOJI LINE
  {
    id: 8,
    type: "text",
    text: "👶🦚",
    x: 380,
    y: 240,
    fontSize: 24,
    fontFamily: "Poppins",
    fill: "#1e40af"
  },

  // ✨ INVITE TEXT
  {
    id: 9,
    type: "text",
    text: "We invite you to join us in celebrating",
    x: 90,
    y: 380,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#050506"
  },

  {
    id: 10,
    type: "text",
    text: "this joyous occasion with love & blessings",
    x: 80,
    y: 420,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#050506"
  },

  // 📅 DATE & TIME (CENTERED BLOCK)
  {
    id: 11,
    type: "text",
    text: "🗓 Sunday, 22 March 2026",
    x: 140,
    y: 490,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#050506"
  },

  {
    id: 12,
    type: "text",
    text: "⏱ 10:00 AM onwards",
    x: 170,
    y: 530,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#050506"
  },

  // ✨ GOLD DIVIDER
  {
    id: 13,
    type: "text",
    text: "✦ ✦ ✦",
    x: 260,
    y: 580,
    fontSize: 30,
    fontFamily: "Poppins",
    fill: "#d4af37"
  },

  // 📍 VENUE
  {
    id: 14,
    type: "text",
    text: "Sri Krishna Function Hall",
    x: 120,
    y: 620,
    fontSize: 30,
    fontFamily: "Playfair Display",
    fill: "#1e3a8a"
  },

  {
    id: 15,
    type: "text",
    text: "Vijayawada",
    x: 220,
    y: 650,
    fontSize: 27,
    fontFamily: "Poppins",
    fill: "#334155"
  },

  // 💫 FOOTER LINE
  {
    id: 16,
    type: "text",
    text: "Bless our little one with your presence 💫",
    x: 100,
    y: 700,
    fontSize: 30,
    fontFamily: "Great Vibes",
    fill: "#1e3a8a"
  },

  // 🦚 DEVOTIONAL
  {
    id: 17,
    type: "text",
    text: "🦚 Jai Shri Krishna 🦚",
    x: 108,
    y: 740,
    fontSize: 36,
    fontFamily: "Great Vibes",
    fill: "#d4af37"
  },

  // BACKGROUND
  {
    id: 18,
    type: "background",
    src: krishna_bg,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  }

];

export default namingceremonyInvitationElements;